import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Dashboard from './components/dashboard/Dashboard'

import ProcedureAndSOP from './components/settings/ProcedureAndSOP.vue'

import Statistic from './components/statistics/Statistic'


import DoctorClinicCode from './components/flowchart/DoctorClinicCode'
import PageNotFound from './components/PageNotFound'
import store from './store/store'

import Clinic from './components/clinic/Clinic.vue'
import Doctor from './components/users/Doctor.vue'
import RegularUser from './components/users/RegularUser.vue'
import ListClinic from './components/users/Clinic.vue'
import ListGroup from './components/users/Group.vue'
import ServiceSetup from './components/settings/ServiceSetup.vue'

import AppointmentDaily from './components/appointment/AppointmentDaily.vue'
import EventGroup from './components/appointment/EventGroup'
import EventBilling from './components/billing/EventBilling'
import EventBillingSettled from './components/billing/EventBillingSettled'

import CalendarDaily from './components/appointment/CalendarDaily'
import DailySaleReport from './components/appointment/DailySaleReport'
import StoreFile from './components/settings/StoreFile.vue'
import Seo from './components/seo/Main.vue'

import LogEPCS from './components/dashboard/LogEPCS.vue'
import SetupPackage from '@/components/settings/SetupPackage.vue'
import SetupPackageWiki from '@/components/settings/SetupPackageWiki.vue'
import NocHcpcsCode from '@/components/emr-data/NocHcpcsCode.vue'
import SmsStats from '@/components/statistics/SmsStats.vue'
Vue.use(Router)
const withPrefix = (prefix, routes) =>
  routes.map((route) => {
    route.path = prefix + route.path
    return route
  })

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'cur',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Dashboard
    },
    {
      path: '/log-epcs',
      name: 'log-epcs',
      component: LogEPCS
    },

    {
      path: '/procedure-and-sop',
      name: 'procedureandsop',
      component: ProcedureAndSOP
    },


    ...withPrefix('/users/', [
      {
        path: 'list-doctor',
        name: 'list-doctor',
        component: Doctor
      },
      {
        path: 'list-regular-user',
        name: 'list-regular-user',
        component: RegularUser
      },

      {
        path: 'list-clinic',
        name: 'list-clinic',
        component: ListClinic
      },
      {
        path: 'list-group',
        name: 'list-group',
        component: ListGroup
      }
    ]),
    {
      path: '/invitation-editor-code',
      name: 'invitationEditorCode',
      component: DoctorClinicCode,
      meta: {}
    },
    {
      path: '/invitation-code',
      name: 'invitationCode',
      component: DoctorClinicCode,
      meta: {}
    },
    {
      path: '/event-billing',
      name: 'eventBilling',
      component: EventBilling,
      meta: {}
    },
    {
      path: '/event-billing-settled',
      name: 'eventBillingSettled',
      component: EventBillingSettled,
      meta: {}
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/404',
      name: 'pageNotFound',
      component: PageNotFound
    },
    {
      path: '/calendar-daily',
      name: 'calendarDaily',
      component: CalendarDaily,
      meta: {}
    },
    {
      path: '/daily-sale-report',
      name: 'dailySaleReport',
      component: DailySaleReport,
      meta: {}
    },
    {
      path: '/appointment-daily',
      name: 'appointmentDaily',
      component: AppointmentDaily,
      meta: { role: ['appointment'] }
    },
    {
      path: '/events-list',
      name: 'eventGroup',
      component: EventGroup,
      meta: {}
    },


    {
      path: '/clinics',
      name: 'clinics',
      component: Clinic
    },
    {
      path: '/service-setup',
      name: 'service-setup',
      component: ServiceSetup
    },
    {
      path: '/store-file',
      name: 'store-file',
      component: StoreFile
    },
    {
      path: '/seo-newsfeed',
      name: 'seo-newsfeed',
      component: Seo
    },
    {
      path: '/seo-question',
      name: 'seo-question',
      component: Seo
    },
    {
      path: '/setup-package',
      name: 'setup-package',
      component: SetupPackage
    },
    {
      path: '/setup-package-wiki',
      name: 'setup-package-wiki',
      component: SetupPackageWiki
    },
    {
      path: '/sms-stats',
      name: 'sms-stats',
      component: SmsStats
    },
    {
      path: '/emr-data/noc',
      name: 'emr-data-noc',
      component: NocHcpcsCode
    },
    {
      path: '/*',
      component: PageNotFound
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'login') {
    if (
      to.name !== 'patientFoodTestSurvey' &&
      to.name !== 'patientRosQuestionnaire' &&
      to.name !== 'patientRequestConsent' &&
      to.name !== 'patientVitalSign'
    ) {
      if (!store.state.authenticated) {
        let email = to.query.email
        store.commit('setUser', { email: email })
        return next({ name: 'login', query: to.query })
      }
      // authenticated
      let role = to.meta.role
    }
  } else {
    if (store.state.workingStatusTimeOut) {
      clearTimeout(store.state.workingStatusTimeOut)
    }
    let email = to.query.email
    if (email) {
      store.commit('setUser', { email: email })
    } else {
      store.commit('setUser', { fullName: '' })
    }
    // reset vuex, set in here, you must update Login.vue
    store.commit('setOpenModalLogin', false)
    store.commit('setAuthenticated', false)
    store.commit('setClinicLocation', '')
    store.commit('setLocations', [])
    store.commit('setUserPermissions', [])
    store.commit('setLocationObject', null)
    store.commit('setStaffs', [])
    store.commit('setSelectedLocation', '')
    store.commit('setSelectedStaff', '')
    store.commit('resetDateFilter', {})
    store.commit('setLockQuestionScreen', false)
    store.commit('resetDataSort')
  }
  next()
})

export default router
